import { render, staticRenderFns } from "./MyRanking.vue?vue&type=template&id=65d2674d&"
import script from "./MyRanking.vue?vue&type=script&lang=js&"
export * from "./MyRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports